import { FC, ReactNode } from "react";

type ButtonProps = {
  children: ReactNode;
  outline: boolean;
  width: number | string;
  height: number;
  disabled: boolean;
  backgroundColor: string;
  color: string;
  borderColor: string;
  fontSize: number;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  style?: React.CSSProperties;
};

export const Button: FC<ButtonProps> = ({
  children,
  outline,
  width,
  height,
  disabled,
  backgroundColor,
  color,
  borderColor,
  fontSize = 16,
  onClick,
  type = "button",
  style = {},
}) => {
  const buttonStyle = {
    width: typeof width === "string" ? width : `${width}px`,
    height: height,
    backgroundColor: backgroundColor,
    color: color,
    borderColor: borderColor,
    fontSize: fontSize,
    borderRadius: height ? (height > 56 ? 20 : 16) : 16,
    boxShadow: "null",
    borderStyle: "solid",
    borderWidth: 1,
    padding: 0,
    cursor: "pointer",
    fontFamily: "Onest",
    ...style,
  };
  return (
    <button
      type={type}
      style={buttonStyle}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
